import axios from "axios";
import { timeoutSmall, urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";

export function GetWallet() {
    return new Promise((resolve, reject) => {
      SecureStorage.getItemAsync("TokenUser").then((token) => {
        var config = {
          method: "get",
          url: getApiUrl(`/api/v1/Wallet`),
          headers: {
            Authorization: "Bearer " + token,
          },
          timeout: timeoutSmall
        };
        axios(config)
          .then((response) => {
            if (response.status == 200) {
              resolve(response.data);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    });
  }